async function search() {
    const productTitles = [];
    const nameproductEle = document.querySelectorAll('.h4.spf-product-card__title a');

    if (nameproductEle.length) {
        nameproductEle.forEach(element => {
            productTitles.push(element.innerHTML);
        });
    }



    const productPromises = productTitles.map(productTitle => {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product')
            .then(response => response.json())
            .then(data => {
                if (data?.resources?.results?.products?.length > 0) {
                    return {
                        title: productTitle,
                        productId: data.resources.results.products[0].id
                    };
                } else {
                    return {
                        title: productTitle,
                        productId: null,
                        message: 'No product found'
                    };
                }
            })
            .catch(error => {
                return {
                    title: productTitle,
                    productId: null,
                    error: 'Error fetching product data: ' + error
                };
            });
    });

    const results = await Promise.all(productPromises);

    results.forEach(result => {
        if (result.productId) {
            nameproductEle.forEach(element => {
                if (element.innerHTML == result.title && !element.hasAttribute('bss-b2b-product-id')) {
                    let card = element.closest('.spf-product__info')
                    let price = card.querySelector('.spf-product-card__price')
                    if (price) {
                        price.setAttribute('bss-b2b-product-id',result.productId )
                        price.setAttribute('bss-b2b-product-price','' )
                    }
                }
            });
        } else {
            console.log(`⚠️ Product Title: ${result.title} - Error: ${result.message || result.error}`);
        }
    });

    return results;
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
}


if (window.location.pathname.includes('/collections')) {
    let loop =  setInterval( async  () => {
      if(document.querySelectorAll('.h4.spf-product-card__title a').length) {
         clearInterval(loop);
        await search(); // 
        // ✅ Notify để cập nhật giá
        const res = await BSS_B2B.storage.productStorage.load();
        if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {

            await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                ...res,
            });

        }
        setTimeout(() => {
        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        }, 100)
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 15000)
}